/**
 * @author 133987
 */
var ssg = ssg || {};
ssg.View = ssg.View || {};
ssg.View.footer = function (htOptions) {
    $.extend(this, htOptions || {});
    this.init();
};

ssg.View.footer.prototype = $.extend({
    _welDoc: null,
    _welWindow: null,
    _welFloatLayer: null,
    nPageTop: 5,
    nScrollTime: 400,
    init: function( ) {
        this._assignElements( );
        this._assignComponents( );
        this._attachEventHandlers( );
        this._fixHistory();
        this._tempStyle();
    },
    _assignElements: function( ) {
        this._welDoc = $( document );
        this._welWindow = $( window );
        this._welFloatLayer = $( '#floating-layer' );
        this._welDefaultToolbar = this._welFloatLayer.find('.m_f_toppd');
        this._welNotifyToolbar = this._welFloatLayer.find('.mcom_bgn');
        this._welPrevBtn = this._welDefaultToolbar.find('.btn_prev');
        this._welTopBtn = this._welDefaultToolbar.find('.btn_top');
        this._welHistoryBtn = this._welDefaultToolbar.find('.btn_history');
        this._welNotifyArea = this._welFloatLayer.find('.m_f_history_gd');

    },
    _assignComponents: function(){
        this.oSsgEventScroll = new ssg.Event.scroll();
    },
    _attachEventHandlers: function( ) {
        var oSelf = this;
        //this.welDoc.on( 'click', 'a[href="#"],area[href="#"]', this._onClickHrefPrevent );
        //this.welDoc.on( 'click', '.fixed_prd .btn_close', $.proxy( this._onClickFloatLayerClose, this ) );
        this._welFloatLayer.on('click', '.btn_top', $.proxy(this._onClickGoTopBtn, this));
        //this._welWindow.on('scroll.spy', $.proxy( this._onScrollWindow, this ));
        //this._welWindow.on("scrollstop.spy", $.proxy( this._onScrollWindow, this ));

        if(this._welDefaultToolbar.length){
            if(this._welNotifyToolbar.length){
                this.oSsgEventScroll.on('scrollDown', $.proxy( this._onScrollDown, this ));
                this.oSsgEventScroll.on('scrollUp', $.proxy( this._onScrollUp, this ));
                this._welWindow.on('scroll.spy', $.proxy( this._onScrollWindowLayer, this ));
            }else{
                this._welWindow.on('scroll.spy', $.proxy( this._onScrollWindowTopBtn, this ));
            }
        }

        if(this._welNotifyArea.is(":visible")){
            ssg.util.wait(1500).done(function(){
                oSelf._welWindow.one('scroll.spy', function(){
                    oSelf._welNotifyArea.hide(0);
                });
            });
        }
    },
    _tempStyle: function(){
        if(typeof isApp !== 'undefined' && isApp === 'Y') {
            this._welHistoryBtn.css('display', 'none');
        }else{
            this._welHistoryBtn.css('display', 'block');
        }
    },
    _onClickGoTopBtn: function (e) {
        e.preventDefault();

        $('html, body').animate({
            scrollTop: 0
        }, this.nScrollTime);
    },
    _onScrollWindowLayer: function(){
        if(this.nPageTop > this._welWindow.scrollTop()){
            this._hideLayer();
        }else{
            this._showLayer();
        }
    },
    _onScrollWindowTopBtn: function(){
        if(this.nPageTop > this._welWindow.scrollTop()){
            this._hideTopBtn();
            this._welHistoryBtn.removeClass('scrl');
        }else{
            this._showTopBtn();
            this._welHistoryBtn.addClass('scrl');
        }
    },
    _onScrollDown: function(nTop){
        this.emit('footer.scrollDown', nTop);
        this._hideNotifyToolbar();
        this._showDefaultToolbar();
    },
    _onScrollUp: function(nTop){
        this.emit('footer.scrollUp', nTop);
        this._hideDefaultToolbar();
        this._showNotifyToolbar();
    },

    _hideLayer: function(){
        if(this._welFloatLayer.is(':visible')){
            this._welFloatLayer.hide(0);
        }
    },
    _showLayer: function(){
        if(this._welFloatLayer.is(':hidden')){
            this._welFloatLayer.stop().fadeIn('fast');
        }
    },
    _hideNotifyToolbar: function(){
        if(this._welNotifyToolbar.is(':visible')){
            this._welNotifyToolbar.hide(0);
        }
    },
    _showNotifyToolbar: function(){
        if(this._welNotifyToolbar.is(':hidden')){
            this._welNotifyToolbar.show(0);
        }
    },
    _hideDefaultToolbar: function(){
        if(this._welDefaultToolbar.is(':visible')){
            this._welDefaultToolbar.hide(0);
        }
    },
    _showDefaultToolbar: function(){
        if(this._welDefaultToolbar.is(':hidden')){
            this._welDefaultToolbar.show(0);
        }
    },
    _hideTopBtn: function(){
        if(this._welTopBtn.is(':visible')){
            this._welTopBtn.hide(0);
        }
    },
    _showTopBtn: function(){
        if(this._welTopBtn.is(':hidden')){
            this._welTopBtn.show(0);
        }
    },
    _fixHistory: function(){
        if(this._welPrevBtn.length && history.length <= 1) {
            this._welPrevBtn.remove();
        }
    }
}, ssg.Event.emitter);